import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { getCurrentStepAsset } from "../../lib/track/currentStepAssets";
import { getCurrentStep } from "../../services/eventService";
import type { CurrentStep } from "../../types/event";

/**
 * TanStack Query hook for GET /api/current-step (Phase 35-03 live mock endpoint).
 * Applies FE thumbnailUrl override from currentStepAssets when an id-keyed asset
 * exists; falls back to the API's `thumbnailUrl` (placehold.co for v1.11) otherwise.
 * (D-04. CSC-FUT-01 deletes this override layer when real CDN-hosted thumbnails ship.)
 */
export function useCurrentStep(): UseQueryResult<CurrentStep> {
	return useQuery<CurrentStep>({
		queryKey: ["currentStep"] as const,
		queryFn: async () => {
			const step = await getCurrentStep();
			const localAsset = getCurrentStepAsset(step.id);
			return localAsset ? { ...step, thumbnailUrl: localAsset } : step;
		},
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
}
